import React, { useState, useEffect } from "react";
import {
    PaymentElement,
    useElements,
    useStripe
} from "@stripe/react-stripe-js";
import { ModalCloseButton, ModalButton, ModalContainer, SpinningIcon, ModalFooter, ModalMessage, CheckoutModalOverlay } from "./CheckoutElements";

const CheckoutModal = ({ isOpen, onClose, setProductModal, clientSecret, setIntentStatus, handleAddNewPurchase }) => {

    const elements = useElements();
    const stripe = useStripe();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!stripe) {
            return;
        }

        if (!clientSecret) {
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            if (!paymentIntent) {
                console.log("no payment intent")
                return;
            }

            if (paymentIntent.status == 'succeeded') {
                console.log("Checking")
                setIntentStatus(paymentIntent.status);
                handleAddNewPurchase('succeeded');
            }
            else {
                console.log(paymentIntent.status)
            }
        });
    }, [stripe, clientSecret]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('here')

        setIsLoading(true);
        setProductModal(false);
        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            console.log("Stripe Elements Not Loaded")
            setIsLoading(false)
            return;
        }


        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: "https://storieswefeel.com/mylibrary",
            },
            redirect: "if_required",
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error) {
            if (error.type === "card_error" || error.type === "validation_error") {
                setMessage(error.message);
            } else {
                setMessage("An unexpected error occurred.");
            }
            setIsLoading(false);
        }
        else {
            setIntentStatus(paymentIntent.status)
            setIsLoading(false);
            handleAddNewPurchase('succeeded')
        }
    };

    const paymentElementOptions = {
        layout: "accordion"
    }

    const handleClose = () => {
        setIsLoading(false);
        onClose()
    }

    if (!isOpen) return null;

    return (
        <CheckoutModalOverlay>
            <ModalContainer id="payment-form" onSubmit={handleSubmit}>
                <PaymentElement id="payment-element" options={paymentElementOptions} />
                <ModalButton disabled={false} id="submit" onClick={(e) => handleSubmit(e)}>
                    {isLoading ? <SpinningIcon /> : "Pay now"}
                </ModalButton>
                {/* Show any error or success messages */}
                <ModalFooter>
                    <ModalCloseButton onClick={handleClose}>Close</ModalCloseButton>
                </ModalFooter>
                {message && <ModalMessage id="payment-message">{message}</ModalMessage>}
            </ModalContainer>
        </CheckoutModalOverlay>
    );
}


export default CheckoutModal;
